import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ceeyu-initlocaldb',
    templateUrl: './initlocaldb.component.html',
    styleUrls: ['./initlocaldb.component.scss']
})
export class InitlocaldbComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
